import { QIcon_heart_filled, QIcon_heart_outline } from '@repo/icons/index'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'
import React from 'react'
import { ANSWER_SHARE_STATUS } from '../../../../model/answer.interface'
import { n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import LessonMoreDropdown, { MenuOption } from '../../lessons/LessonMoreDropdown'

interface ViewAnswerItemProps {
  item: any
  isShareAnswers?: boolean
  optionList?: MenuOption[]
  likeCounts?: number
  onLikeClick?: any
  isIconActive?: boolean
  customClassName?: string
}

const DateFormat = ({ date, formatStr = 'yyyy.MM.dd', className }) => {
  const dateFnsLocale = enUS // Fallback to enUS if the locale is not found
  const formattedDate = format(new Date(date), formatStr, { locale: dateFnsLocale })

  return <span className={className}>{formattedDate}</span>
}

// 내 답변과 다른 링글러의 답변 보는 컴포넌트
const ViewAnswerItem = ({
  item,
  isShareAnswers = false,
  optionList,
  likeCounts,
  onLikeClick,
  isIconActive,
  customClassName,
}: ViewAnswerItemProps) => {
  const { t } = useTranslation()
  const created_at = item.created_at
  const content = item.answer ? item.answer.content : item.content
  const share_status =
    item.share_status === ANSWER_SHARE_STATUS.ME
      ? t(n_lesson_prep.answer_scope_option2)
      : item.share_status === ANSWER_SHARE_STATUS.PUBLIC
      ? t(n_lesson_prep.answer_scope_option1)
      : t(n_lesson_prep.answer_scope_option3)
  const isTutor = item.author?.role == 'Tutor'

  const contentWithBreaks = content.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ))

  return (
    <div className={`flex flex-col space-y-16 ${customClassName && customClassName}`}>
      <div className="flex w-full flex-col space-y-4 px-20 py-16">
        {/** 날짜 및 버튼 */}
        <div className="flex w-full">
          <div className="flex space-x-8">
            <div className="flex flex-col space-y-4">
              <div className="flex flex-row">
                {isShareAnswers && <div className="font-bold ">ID {item.author.name}</div>}
                {isTutor && (
                  <div className="Caption-12Bd ml-[8px] rounded-[4px] bg-gray-100 px-[6px] pt-[3px] text-gray-600">
                    Tutor
                  </div>
                )}
              </div>
              <div className="flex space-x-8">
                {isShareAnswers ? (
                  <span className="text-[14px] font-medium text-gray-500">{created_at}</span>
                ) : (
                  <DateFormat date={created_at} className="text-16 font-medium text-gray-500" />
                )}
                {!isShareAnswers && (
                  <div className="text-12 rounded-[4px] bg-gray-100 px-6 py-2 font-bold text-gray-600">
                    {share_status}
                  </div>
                )}
                {item.authtor?.role == 'Tutor' && (
                  <div className="text-12 rounded-[4px] bg-gray-100 px-6 py-2 font-bold text-gray-600">Tutor</div>
                )}
                {item.answer?.source_origin == 'DAILY_STUDY' && (
                  <div className="text-12 rounded-[4px] bg-purple-50 px-6 py-2 font-bold text-purple-600">
                    {t(n_lesson_prep.answer_tag4)}
                  </div>
                )}
              </div>
            </div>
          </div>
          {!isShareAnswers && (
            <div className="ml-auto">
              <LessonMoreDropdown optionList={optionList} isLeft={true} />
            </div>
          )}
        </div>
        {/** 답변 body */}
        <div className="font-16 font-medium text-black">{contentWithBreaks}</div>
      </div>
      {/* 좋아요 */}
      <div className="flex px-20">
        <div className="w-full"></div>
        <div className="ml-auto flex space-x-4">
          {!isIconActive ? (
            <QIcon_heart_outline onClick={onLikeClick} className="cursor-pointer" />
          ) : (
            <QIcon_heart_filled onClick={onLikeClick} className="cursor-pointer" />
          )}
          <div className="text-14 font-medium text-gray-500">{likeCounts}</div>
        </div>
      </div>
    </div>
  )
}

export default ViewAnswerItem
